import {Injectable} from '@angular/core';
import {ApiBaseService} from '@shared/services/api/api-base.service';

@Injectable()
export class SalaryTimeService extends ApiBaseService{
  route_prefix = 'salary-times';
}
